import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M10.024 13.474c-.071-1.16-.196-3.207-.259-4.383-.027-.49.384-.897.902-.897h1.517c.518 0 .928.406.901.897l-.25 4.383c-.026.457-.419.813-.9.813h-1.018c-.473-.017-.866-.364-.893-.813"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M20.877 15.836c-1.473-5.06-7.274-13.413-10.54-11.577-1.152.643-7.212 7.794-7.283 13.463-.045 3.503 8.8 3.749 14.95 2.547a4.45 4.45 0 0 0 1.954-.897c.553-.448.982-1.058.205-1.404-2.187-.974-2.963 3.088.714 2.335"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M11.613 18.487c.828 0 1.5-.637 1.5-1.422s-.672-1.422-1.5-1.422-1.5.637-1.5 1.422.672 1.422 1.5 1.422"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const WarningIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
